import React from 'react';

interface GoogleMapProps {
  className?: string;
  height?: string;
}

export const GoogleMap: React.FC<GoogleMapProps> = ({ 
  className = "", 
  height = "400px" 
}) => {
  return (
    <div className={`w-full ${className}`} style={{ height }}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d25652.38724843658!2d-4.9016!3d36.5097!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72d7fdb909e359%3A0x2a446965d0f7fc6a!2sMarbella%2C%20M%C3%A1laga%2C%20Spain!5e0!3m2!1sen!2s!4v1234567890123!5m2!1sen!2s"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Aureum VII Trading Marbella Location"
        className="rounded-lg"
      />
    </div>
  );
};
